import CategoryIcon from "@material-ui/icons/Category";
import LabelIcon from "@material-ui/icons/Label";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import DonutLargeIcon from "@material-ui/icons/DonutLarge";

import { AppResource } from "../../../types/resource.types";
import ChallengesList from "../../Challenges";
import Chat from "../../Chat";
import { CourtsCreate, CourtsEdit, CourtsList } from "../../Courts";
import CourtAvailability from "../../Courts/components/Availability";
import CourtSlotsCalendar from "../../Courts/components/Calendar";
import { CourtsReservationsList } from "../../CourtsReservations";
import ClubDashboard from "./Dashboard";
import AccountSettings from "../../AccountSettings";
import SportClubProfile from "../../Profiles/SportClubProfile";
import SportClubFullNotificationList from "../../SportsClubs/SportsClubsNotifications/SportClubFullNotificationList";

export const clubAccount = {
  resources: [
    <Resource
      name={AppResource.courts}
      list={CourtsList}
      edit={CourtsEdit}
      create={CourtsCreate}
      icon={CategoryIcon}
      options={{
        label: "Courts",
      }}
    />,
    <Resource
      name={AppResource.challenges}
      list={ChallengesList}
      icon={DonutLargeIcon}
      options={{
        label: "Challenges",
      }}
    />,
    <Resource
      name={AppResource.courtsReservations}
      list={CourtsReservationsList}
      icon={LabelIcon}
      options={{
        label: "Reservations",
      }}
    />,
    <Resource name={AppResource.courtsCategories} />,
    <Resource name={AppResource.clients} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.courtAvailabilities}/:courtId`} component={CourtAvailability} />,
    <Route exact path={`/${AppResource.courtsSlotsCalendar}/:courtId`} component={CourtSlotsCalendar} />,
    <Route exact path={`/${AppResource.chat}/:roomId`} component={Chat} />,
    <Route exact path={`/${AppResource.settings}`} component={AccountSettings} />,
    <Route exact path={`/${AppResource.profile}`} component={SportClubProfile} />,
    <Route exact path={`/${AppResource.notifications}`} component={SportClubFullNotificationList} />,
  ],
  dashboard: ClubDashboard,
};
